<template>
<body>
  <div class="dataUpload">
    <div class="upload-contacts_info">
      <div class="upload-contacts_info_line">
        <div class="contacts-info-top">
          <div class="contacts-info-name">
            <em>姓名:</em>
            <em>{{data_param.name}}</em>
          </div>
          <div class="contacts-info-type">
            <em>所属类型:</em>
            <em>{{data_param.type_name}}</em>
          </div>
          <div class="contacts-info-type">
            <em class="member_info_data">共有{{getDataLength}}项资料</em>
          </div>
        </div>
      </div>
      <div class="upload-contacts_info_line">
        <div class="upload-type">
          <span>上传类型</span>
          <div class="upload-contacts_info_input">
            <!-- <select v-model="current_required">
              <option v-for="(item, index) in upload_type" :value="item.system_config.system_config_id" :key="index">
              {{item.system_config.key_name}}
              </option>
            </select>-->
            <div id="not-border-select-style">
              <select id="not-border-select" style="font-size: 18px;" v-model="current_required">
                <option value="0"></option>
                <option
                  :key="index"
                  :value="item.system_config.system_config_id"
                  v-for="(item, index) in getUploadType"
                >{{item.system_config.key_name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="upload-contacts_info_line">
        <div class="upload">
          <div class="left">
            <i style="line-height: normal;vertical-align: middle;">*</i>
            <em>上传图片</em>
          </div>
          <div class="right">
            <!-- <div class="hint">
              <em>上传成功!</em>
            </div>-->
            <div class="hint">
              <em>注: 单个文件最大10MB</em>
            </div>
            <div style="font-size: 18px;">
              <fy-file class="date-upload" ref="fileChild" v-model="file"></fy-file>
            </div>
            <div class="upload-btn">
              <input
                @click="uploadsubmits"
                name="upload"
                ref="uploadFile"
                type="button"
                value="开始上传"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="date-name-title">
        <h1 class="date-name">资料名称</h1>
      </div>
      <div class="upload-contacts_info_line" v-for="(file, index) in fileinfo">
        <div class="upload-contacts_info_input">
          <div>
            <div class="data-name-item">
              <p class="name">
                <a
                  :href="url_info[getAttaId(index)]"
                  class="url_a"
                  target="_blank"
                  v-if="url_info['type_'+getAttaId(index)] == 'doc'"
                >{{getDataName(index)}}</a>
                <a
                  @click="previewImg(url_info[getAttaId(index)], getDataName(index))"
                  class="url_a"
                  v-else
                >{{getDataName(index)}}</a>
              </p>
              <p
                @click="deletedata(index)"
                class="delete"
                v-if="getDataState(index) == 0 || flag_info['flag_' + index] == 'tmp' "
              >
                <a>
                  <i>X</i>删除
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="upload-contacts_info_line">
        <div class="submit-btn">
          <input @click="save" name="submit" type="button" value="提交">
        </div>
      </div>
    </div>
    <popup-img-dialog
      :previewInfo="previewInfo"
      @closeDialog="close"
      v-show="previewInfo.showDialog"
    ></popup-img-dialog>
  </div>
</body>
</template>
<script>
import { FyFile } from '@/components/form'
import { PopupImgDialog } from '@/components/imgDialog'
export default {
  name: "dataUpload",
  components: { PopupImgDialog, FyFile },
  data () {
    return {
      data_param: {
        name_list_info_id: 0,
        order_id: 0,
        plan_id: 0,
        name: '',
        type: '', // 当前 所属类型值
        type_name: '', // 当前 所属类型名称
      },
      required_data: {}, // 上传类型 所有的所属类型和上传类型，考虑去掉
      person_type: {}, // 所属类型
      upload_type: [], // 上传类型 当前 所属类型关联的上传类型
      plan_type: [],
      data_detail: {}, // 名单关联的签证信息
      //current_type:'0', // 当前 所属类型值
      //current_type_name:'', // 当前 所属类型名称
      current_required: '', // 当前 上传类型值
      current_select_file_name: '', // 当前 选择文件的名称
      url_info: {},
      atta_list: [],

      fileinfo: {},
      required: {}, // 已上传的类型
      flag_info: {},
      allData: new FormData(),

      previewInfo: {
        title: '',
        url: '',
        showDialog: false
      },

      file: '',
    }
  },
  props: {
    params: Object
  },
  watch: {
    file (value) {
      this.upload(value)
    }
  },
  computed: {
    getDataLength () {
      return this.upload_type.length
    },
    // 取上传类型， 如果已经上传了就不显示该类型了
    getUploadType () {
      var newType = []
      for (var index in this.upload_type) {
        var type = this.upload_type[index].system_config.system_config_id
        if (!this.fileinfo[type]) {
          //newType.push[this.upload_type[type]]
          this.$set(newType, newType.length, this.upload_type[index])
        }
      }
      return newType
    },
  },
  mounted () {

  },
  created () {
    this.data_param.name_list_info_id = this.params.name_list_info_id
    this.data_param.order_id = this.params.order_id
    this.data_param.name = this.params.name
    this.data_param.plan_id = this.params.plan_id
    this.data_param.type = this.params.type
    this.data_param.type_name = this.params.type_name
    this.initData();
  },
  methods: {
    // 初始化页面数据
    initData () {
      this.$myGet('order_route/data/' + this.data_param.plan_id + '/'
        + this.data_param.name_list_info_id + '/' + this.data_param.order_id + '/' + this.data_param.type)
        .then(res => {
          const rcode = res.response.data.rcode
          if (rcode == 0) {
            this.required_data = res.response.data.system_config_vos_map
            this.person_type = res.response.data.categorys
            this.upload_type = res.response.data.sc_list
            this.data_detail = res.response.data.data_detail
            this.plan_type = res.response.data.visa_plan_type

            this.url_info = res.response.data.atta_url_info
            this.atta_list = res.response.data.atta_list
            var dataList = res.response.data.atta_list
            for (let data in dataList) {
              var tableName = dataList[data].table_name
              tableName = tableName.substring('new_name_list_info_'.length, tableName.length)
              if (this.plan_type.indexOf(tableName) > -1) {
                this.fileinfo[tableName] = dataList[data].file_name
                this.flag_info['flag_' + tableName] = 'formal' // 附件标记 正式
                this.required['required_type_' + tableName] = dataList[data].table_rec_id
              }
            }
          } else {
            this.$msg('[' + res.status + ']' + res.response.data.messages[0].msg, 'error', 3000)
          }
        })
        .catch(err => {
          this.$msg('[' + err.status + ']' + err.message)
        })
    },
    save () { // 提交
      if (!this.validate()) {
        this.$msg('请添加完整资料', 'error', 3000)
        return
      }
      var loading = this.$loadingIndicator.eleOpen('正在提交...')
      try {
        const params = {}
        this.$util.copyObj2Obj(params, this.required)
        this.$util.copyObj2Obj(params, this.fileinfo)
        this.$util.copyObj2Obj(params, this.flag_info)
        params['name_list_info_id'] = this.data_param.name_list_info_id
        params['current_type'] = this.data_param.type
        params['route_plan_id'] = this.data_param.plan_id
        params['order_info_id'] = this.data_param.order_id
        params['name'] = this.data_param.name
        params['type_name'] = this.data_param.type_name
        params['action'] = 'save'

        this.$myGet('visa_data_upload/save', params)
          .then(res => {
            var reMap = res.response.data.re_map
            let code = reMap.rcode
            loading.close()
            if (code >= 0) {
              this.$msg(reMap.msg, 'success', 3000)
              this.toReview()
            } else {
              this.$msg(reMap.msg + '，code：' + code, 'error', 3000)
            }
          })
          .catch(err => {
            loading.close()
            this.$msg('上传失败！', 'error', 3000)
          })
      } catch (error) {
        loading.close()
      }
    },
    // 开始上传
    uploadsubmits () {
      if (!this.current_required || this.current_required == 0) {
        this.$msg('请选择上传类型', 'info', 3000)
        return
      }
      var loading = this.$loadingIndicator.eleOpen('正在上传...')
      try {
        this.$myUpload('visa_data_upload/uploads', this.allData).then((res) => {
          var reMap = res.response.data.re_map
          var codeObj = eval('(' + reMap.atta_info + ')')
          var tableId = codeObj[0].table_rec_id
          var attaId = codeObj[0].atta_id
          //console.log('上传res:'+res.data);
          if (!tableId) {
            loading.close()
            this.$msg('请重新选择类型或添加图片', 'error', 1000)
            return
          }
          this.$set(this.fileinfo, this.current_required, this.current_select_file_name)
          this.required['required_type_' + this.current_required] = tableId
          this.flag_info['flag_' + this.current_required] = 'tmp' // 将上传的资料标记为临时文件
          this.url_info[attaId] = reMap['url_' + attaId]
          this.url_info['type_' + attaId] = reMap['type_' + attaId]
          this.$set(this.atta_list, this.atta_list.length, { 'attachment_info_id': attaId, 'table_name': 'new_name_list_info_' + this.current_required })

          // 重置file 上传控件 
          // document.getElementById('upload').value = ''
          this.initFileChild()
          this.current_required = ''
          loading.close()
          this.$msg(reMap.msg, 'success', 2000)
        }).catch(err => {
          console.error(err)
          loading.close()
          this.$msg('上传失败', 'error')
        })
      } catch (error) {
        loading.close()
      }
    },
    // 重置file 上传控件 
    initFileChild () {
      this.$refs.fileChild.resetField()
    },
    // 删除附件
    deletedata (index) {
      this.$delete(this.fileinfo, index)
      this.$delete(this.flag_info, 'flag_' + index)
      this.$delete(this.required, 'required_type_' + index)
      for (var i in this.atta_list) {
        var atta = this.atta_list[i]
        var tableName = atta.table_name
        if (this.$util.startWith(tableName, 'new_name_list_info_')) {
          tableName = this.$util.subStr(tableName, 'new_name_list_info_')
        }
        if (tableName == index) {
          this.atta_list.splice(i, 1)
        }
      }
      // 删除资料附件链接
      var attaId = this.getAttaId(index)
      this.$delete(this.url_info, attaId)
      this.$delete(this.url_info, 'type_' + attaId)
    },
    // 选择文件时 [xsw 修改]
    upload (file) {
      this.allData = new FormData()
      if (this.required['required_type_' + this.current_required]) {
        this.$msg(this.current_required + '已上传了文件，请选择另一个类型上传！');
        // document.getElementById('upload').value = ''
        this.initFileChild()
        return
      }
      if (!file) return;
      this.current_select_file_name = file.name
      this.allData.append('file', file)
    },
    getFileLength () {
      var i = 0
      for (let key in this.fileinfo) {
        i++
      }
      return i;
    },
    // 取资料文件的审核状态
    getDataState (type) {
      var state = ''
      for (var i in this.data_detail) { //  取状态，是否合格  -1 未审核， 0 否  1 是
        if (this.data_detail[i].id == type) {
          state = this.data_detail[i].status
        }
      }
      return state
    },
    getDataName (type) {
      for (var index in this.upload_type) {
        var id = this.upload_type[index].system_config.system_config_id
        if (type == id) {
          return this.upload_type[index].system_config.key_name
        }
      }
      return ''
    },
    //跳转到审核页
    toReview () {
      this.$domUtils.dispatch(this, 'OrderDetail', 'close.dialog.reload', true)  //关闭弹框时刷新页面
      this.$domUtils.dispatch(this, 'DataParent', 'cut.data', this.data_param)
    },
    // 验证必选资料是否上传
    validate () {
      var requiredList = this.required_data[this.data_param.type]
      for (var planType in this.plan_type) {
        for (var requiredData in requiredList) {
          var type = requiredList[requiredData]['system_config']['system_config_id']
          if (this.plan_type[planType] == type && requiredList[requiredData]['system_config']['key_value'] == '1' && !this.fileinfo[type]) {
            return false
          }
        }
      }
      return true;
    },
    getAttaId (type) {
      if (!this.atta_list) {
        return
      }
      for (var index in this.atta_list) {
        var atta = this.atta_list[index]
        var tableName = atta.table_name
        if (this.$util.startWith(tableName, 'new_name_list_info_')) {
          tableName = this.$util.subStr(tableName, 'new_name_list_info_')
        }
        if (tableName == type) {
          return atta.attachment_info_id
        }
      }
    },
    // 预览图片
    previewImg (url, title) {
      this.previewInfo.url = url
      this.previewInfo.title = title
      this.previewInfo.showDialog = true
    },
    close () {
      this.previewInfo.showDialog = false;
    }
  }
}
</script>

<style scoped>
@import '../../../assets/css/pages/customer/css.css';
.member_info_name span {
  padding-right: 29px;
}
* {
  margin: 0;
  padding: 0;
}
.url_a {
  cursor: pointer;
}
.show {
  width: 100px;
  height: 100px;
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  border: 1px solid #d5d5d5;
}
.picture {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/p_center/dataUpload.vue